// icon:bxs-right-arrow | Boxicons https://boxicons.com/ | Atisa
import * as React from "react";

function IconBxsRightArrow(props) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      height="1em"
      width="1em"
      {...props}
    >
      <path d="M5.536 21.886a1.004 1.004 0 001.033-.064l13-9a1 1 0 000-1.644l-13-9A1 1 0 005 3v18a1 1 0 00.536.886z" />
    </svg>
  );
}

export default IconBxsRightArrow;
